// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".half-circle-spinner .circle-1{border-top-color:#00758d!important}.half-circle-spinner .circle-2{border-bottom-color:#ff9e18!important}.v-application--wrap h1.display-1,.v-application--wrap h2.display-1,.v-application--wrap h3.display-1{color:#51307d;margin-bottom:16px}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#00758d",
	"secondaryColor": "#001c71",
	"accentColor": "#081f2d"
};
module.exports = exports;
